<template>
  <div class="main-container">
    <ThemedTapBar
      :tabs="items"
      v-model="currentTabModel"
      grow
      @input="changeCalculationType"
    />

    <div class="content-container">
      <v-tabs-items v-model="currentTabModel">
        <v-tab-item>
          <InteractiveCalculationView ref="interactiveView" />
        </v-tab-item>
        <v-tab-item>
          <PresetCalculationView />
        </v-tab-item>
      </v-tabs-items>
    </div>

    <div class="button-container">
      <CustomThemedButton
        class="main-button"
        rounded
        height="32"
        block
        @click="calculateKd"
        :loading="calculationLoading"
        :disabled="isCalculateDisabled"
      >
        Calculate
      </CustomThemedButton>
      <v-btn
        rounded
        icon
        color="var(--color-secondary)"
        @click="$emit('collapseButtonPressed')"
      >
        <v-icon>mdi-chevron-double-left</v-icon>
      </v-btn>
    </div>
  </div>
</template>

  <script>
import InteractiveCalculationView from "./InteractiveCalculationView.vue";
import PresetCalculationView from "../presets/PresetCalculationView.vue";
import { mapState, mapGetters, mapActions } from "vuex";
import ThemedTapBar from "@/core/ThemedTapBar.vue";
import CustomThemedButton from "@/core/CustomThemedButton.vue";
export default {
  name: "CategoriesDrawer",
  components: {
    InteractiveCalculationView,
    ThemedTapBar,
    PresetCalculationView,
    CustomThemedButton,
  },
  props: {},
  data() {
    return {
      drawer: true,
      items: ["Interactive", "Preset"],
      currentTabModel: 0,
    };
  },
  computed: {
    ...mapState("kDiagram", [
      "calculationResult",
      "calculationData",
      "calculationType",
      "calculationLoading",
    ]),
    ...mapState("kDiagram/profiles", ["profiles", "selectedProfile"]),
    ...mapGetters("kDiagram", [
      "rpmPowerSeries",
      "speedPowerSeries",
      "powerConsumptionSeries",
      "speedConsumptionSeries",
      "rpmConsumptionSeries",
      "valueTableData",
    ]),
    isCalculateDisabled() {
      return this.calculationType === "preset" && this.selectedProfile == null;
    },
  },
  methods: {
    ...mapActions("kDiagram/profiles", ["fetchProfiles"]),
    ...mapActions("kDiagram", ["calculateByPreset", "calculate"]),
    changeCalculationType() {
      const calculationType = this.currentTabModel === 0 ? "input" : "preset";
      this.$store.commit("kDiagram/SET_CALCULATION_TYPE", calculationType);
    },
    async calculateKd() {
      const interactiveForm = this.$refs.interactiveView;
      if (this.calculationType === "input") {
        if (!interactiveForm.validate()) {
          return;
        }
        await this.calculate(this.$route.params.vessel);
      } else {
        await this.calculateByPreset({
          vessel: this.$route.params.vessel,
          profileId: this.selectedProfile.id,
        });
      }
    },
  },
};
</script>




<style scoped>
::v-deep .v-window {
  background-color: var(--color-bg) !important;
  border-radius: var(--radius-md);
}

.content-container {
  height: 100%;
  background-color: var(--color-bg);
  overflow-y: auto;
  padding: 10px;
  margin-top: 8px;
}

.main-container {
  height: 100%;
  background-color: var(--color-bg);
  display: flex;
  flex-direction: column;
}

.button-container {
  display: flex;
  flex-direction: row;
  gap: 10px;
  justify-content: space-between;
  padding: 10px 20px 10px 10px;
}

.main-button {
  background-color: var(--color-secondary) !important;
  color: var(--color-text) !important;
}
</style>
